import React from 'react';
import { Path } from 'react-native-svg';
import SVGIcon from './SVGIcon';
import withDefaultIconProps from './withDefaultIconProps';
const CloseIcon = ({ color, ...rest }) => {
    return (React.createElement(SVGIcon, { ...rest },
        React.createElement(Path, { d: "M18.295 7.115a.997.997 0 10-1.41-1.41L12 10.59 7.115 5.705a.997.997 0 00-1.41 1.41L10.59 12l-4.885 4.885a.997.997 0 001.41 1.41L12 13.41l4.885 4.885a.997.997 0 101.41-1.41L13.41 12l4.885-4.885z", fill: color })));
};
export default withDefaultIconProps(CloseIcon);
